import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQ = () => {
  const faqs = [
    {
      question: "Hva koster det?",
      answer:
        "For bedrifter er det helt gratis å ha en B-Labs stasjon. Vi tar oss av alt – du trenger bare å tilby plassen. Sluttbrukere betaler en liten sum per utleie via app eller Vipps.",
    },
    {
      question: "Må vi gjøre noe selv?",
      answer:
        "Nei, vi håndterer alt. Installasjon, vedlikehold, påfylling av powerbanker og teknisk support er inkludert. Dere trenger bare å plugge inn stasjonen i en stikkontakt.",
    },
    {
      question: "Hva skjer hvis powerbanken ikke leveres tilbake?",
      answer:
        "Kunden blir automatisk belastet for verdien av powerbanken etter en viss tid. Dette håndteres helt automatisk gjennom appen – dere trenger ikke å gjøre noe.",
    },
    {
      question: "Hvor lang leveringstid er det?",
      answer:
        "Vi har normalt stasjoner på lager og kan levere innen 1-2 uker. Ved større bestillinger eller spesialdesign kan leveringstiden variere.",
    },
    {
      question: "Kan vi få egen branding?",
      answer:
        "Ja! Vi tilbyr full tilpasning av stasjonene med din logo, farger og design. Ta kontakt for et skreddersydd tilbud.",
    },
  ];

  return (
    <section
      id="faq"
      className="py-24 md:py-32 bg-[#0A0A0A]"
      data-testid="faq-section"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FFD84D] mb-4 block">
            Spørsmål
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white font-['Outfit']">
            Ofte stilte spørsmål
          </h2>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-[#121212] border border-white/5 rounded-xl overflow-hidden"
              data-testid={`faq-item-${index + 1}`}
            >
              <AccordionTrigger className="px-6 py-5 text-left text-white font-medium hover:text-[#FFD84D] hover:no-underline transition-colors [&[data-state=open]]:text-[#FFD84D]">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-5 text-[#A1A1AA] leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
